module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/demos/inner-pages/customer-story-46b237052b0a25e269646eb7b596255c.png";